import React from 'react';
import PropTypes from 'prop-types';
import { Button, Image } from '@express-labs/raven-ui';
import Toaster from '../Toaster';
import routes from '../../../../../routes/routes';
import s from './NotificationCard.module.scss';

function NotificationCard(props) {
  const {
    show, className, onRequestClose, imageSrc, subtotal, alt,
  } = props;

  const handleClick = () => {
    window.location.assign(routes.bag.path);
  };

  const handleKeydown = (e) => {
    if (e.key === 'Enter') {
      handleClick();
    }
  };

  return (
    <Toaster
      show={show}
      className={className}
      onRequestClose={onRequestClose}
      onClick={handleClick}
      onKeyDown={handleKeydown}
    >
      <Image className={s.bagNotificationImage} src={imageSrc} alt={alt} responsive />
      <div className={s.rightPanel}>
        <p className={s.message}>Item added to your bag</p>
        {subtotal && (
          <p>
            Subtotal:
            {' '}
            <span className={s.price}>{subtotal}</span>
          </p>
        )}
        <Button onClick={handleClick} aria-label="view bag">
          View Bag
        </Button>
      </div>
    </Toaster>
  );
}

NotificationCard.meta = {
  VERSION: '1.0.0',
};

NotificationCard.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  imageSrc: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  subtotal: PropTypes.string,
  onRequestClose: PropTypes.func,
};

NotificationCard.defaultProps = {
  alt: 'bag notification image',
  className: null,
  onRequestClose: null,
  subtotal: null,
};

export default NotificationCard;
